<div class="offcanvase-side">
  <div
    class="offcanvas offcanvas-end navbar-brand-box p-0 z-1"
    style="
      top: 70px;
      width: 360px !important;
      visibility: visible !important;
      height: calc(100vh - 70px);
    "
    data-bs-scroll="true"
    data-bs-backdrop="false"
    tabindex="-1"
    id="offcanvasScrollingAIConf"
    aria-labelledby="offcanvasScrollingLabel"
  >
    <div class="offcanvas-header ps-0 mb-0 offcanvas-divider">
      <div id="sidebar-menu" class="p-0 offcanvas-header">
        <ul class="metismenu list-unstyled">
          <li draggable="false">
            <a class="side-nav-link-ref">
              <h5 class="mb-0">{{ title }}</h5>
            </a>
          </li>
        </ul>
      </div>
      <div
        class="text-reset enablePointer"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        (click)="hideOffcanvas()"
      >
        <i class="mdi mdi-close font-size-22 icon-close"></i>
      </div>
    </div>
    <div class="card-body px-2 py-2 d-flex flex-column justify-content-end flex-grow-1 position-relative overflow-hidden">
      <div #messagesContainer class="d-flex flex-column align-items-center flex-grow-1 overflow-auto invisible-scrollbar" style="z-index: 1">
        <div *ngFor="let message of messages" class="d-flex flex-shrink-0 rounded-4 w-100 mb-2 pb-2" style="min-height: 60px; max-width: 800px; animation: slideUp 5s linear;" [ngClass]="message.role == 'user' ? 'border ai-card' : ''">
          <div class="ps-2 pe-3 pt-2">
            <div *ngIf="message.role == 'assistant'" class="position-relative d-flex align-items-end" style="width: 20px; height: 30px">
              <img src="assets/images/ai-icon.svg" style="width: 20px">
              <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
            </div>
            <div
              *ngIf="message.role == 'user'"
              class="rounded-circle avatar-xxs mt-1"
              [ngStyle]="{'background': getLogoBackground()}"
            >
              <img
                [src]="app_icon"
                class="rounded-4 img-fluid object-fit-fill"
                alt=""
                height="50"
                onerror="this.onerror=null; this.src='assets/images/users/logo.webp'"
              />
            </div>
          </div>
          <div class="pt-2_9 overflow-none text-wrap text-break text-start pe-1">
            <span *ngIf="message.role == 'user'" class="message-text mt-2 mb-1 fw-bolder" [innerHTML]="message?.content"></span>
            <!-- Typing animation for the last assistant message -->
            <markdown *ngIf="message.role == 'assistant' && last" class="message-text mb-1 mt-2 text-start" [data]="displayedMessage"></markdown>

            <!-- Fully loaded message for non-last assistant messages -->
            <markdown *ngIf="message.role == 'assistant' && !last" class="message-text mb-1 mt-2 text-start" [data]="message?.content"></markdown>
          </div>
        </div>
        <div *ngIf="loadingMessage && !isProcessingQueue" class="d-flex flex-shrink-0 border rounded-4 ai-card w-100 mb-2" style="min-height: 60px; max-width: 800px; animation: slideUp 5s linear;">
          <div class="d-flex px-3 pt-2">
            <div class="position-relative d-flex align-items-end" style="height: 30px">
              <img src="assets/images/ai-icon.svg" class="big-star" style="width: 20px">
              <img src="assets/images/ai-icon.svg" class="small-star position-absolute" style="width: 10px; top: 4px; right: -6px">
            </div>
            <span *ngIf="thinkingMessage" class="thinking ms-3 mt-2">
              <span class="text">Thinking</span>
              <span class="shimmer"></span>
            </span>
            <div *ngIf="!thinkingMessage" class="typing-indicator ms-3 mt-1">
              <span class="dot dot-1"></span>
              <span class="dot dot-2"></span>
              <span class="dot dot-3"></span>
            </div>
          </div>
        </div>
        <div *ngIf="errorMessage" class="card ai-card border rounded-4 chatMessage w-100" style="max-width: 800px" [ngClass]="{'dark': mode == 'dark' }">
          <div class="card-body  border rounded-4">
            <div class="d-flex flex-column flex-sm-row">
              <div class="position-relative d-flex align-items-end" style="height: 30px">
                <img src="assets/images/ai-icon.svg" style="width: 20px">
                <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
              </div>
              <div class="d-flex flex-column ps-3 message-text">
                <span class="fw-bold mt-2 mb-1">AI Unavailable</span>
                <span class="mb-2">The AI has experienced an error please refresh or try again later</span>
              </div>
            </div>
          </div>
        </div>




        <div *ngIf="doneMessage" class="card ai-card border rounded-4 chatMessage w-100" style="max-width: 800px" [ngClass]="{'dark': mode == 'dark' }">
          <div class="card-body  border rounded-4">
            <div class="d-flex flex-column flex-sm-row">
              <div class="d-flex align-items-center align-items-sm-start justify-content-start">
                <div class="position-relative d-flex align-items-end" style="width: 20px; height: 30px">
                  <img src="assets/images/ai-icon.svg" style="width: 20px">
                  <img src="assets/images/ai-icon.svg" class="position-absolute" style="width: 10px; top: 4px; right: -6px">
                </div>
                <span class="d-block d-sm-none text-muted font-size-12 mt-2 ms-3">AI Assistant</span>
              </div>

              <div *ngIf="module =='bot'" >
                <div *ngIf="web =='generate'">
                  <div class="d-flex flex-column ps-3 message-text">
                    <span class="fw-bold mt-2 mb-1">You're all set!</span>
                    <span class="mb-2">Click Generate to create and launch your bot</span>
                    <div>
                      <button class="btn w-lg  btn-primary rounded-pill" (click)="generateApp(module, web)">
                        Generate
                      </button>
                    </div>
                  </div>
                </div>


                <div *ngIf="web=='update'">
                  <div class="d-flex flex-column ps-3 message-text">
                    <span class="fw-bold mt-2 mb-1">You're all set!</span>
                    <span class="mb-2">We've gathered all your custom configurations to build your app just the way you envision it. When you click Generate App, your app will be created with all your settings, and you'll be taken to the full app builder interface where you can:</span>
                    <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">See a Real-Time Preview: </span>Watch as your design and navigation come to life.</span></span>
                    <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Customize Navigation & Layout: </span>Adjust tabs, menus, and overall flow to suit your needs.</span></span>
                    <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Refine Branding & Side Menu: </span>Set your app's identity and add extra native components.</span></span>
                    <span class="mb-2 d-flex align-items-center justify-content-start"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Tweak Settings & Build Details: </span>Fine-tune everything from language and theme to payment and authentication.</span></span>
                    <div>
                      <button class="btn w-lg  btn-primary rounded-pill" (click)="generateApp(module, web)">
                        Generate
                      </button>
                    </div>
                  </div>
                </div>

              </div>




              <!-- <div class="d-flex flex-column ps-3 message-text">
                <span class="fw-bold mt-2 mb-1">You're all set!</span>
                <span class="mb-2">We've gathered all your custom configurations to build your app just the way you envision it. When you click Generate App, your app will be created with all your settings, and you'll be taken to the full app builder interface where you can:</span>
                <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">See a Real-Time Preview: </span>Watch as your design and navigation come to life.</span></span>
                <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Customize Navigation & Layout: </span>Adjust tabs, menus, and overall flow to suit your needs.</span></span>
                <span class="mb-2 d-flex align-items-center"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Refine Branding & Side Menu: </span>Set your app's identity and add extra native components.</span></span>
                <span class="mb-2 d-flex align-items-center justify-content-start"><span class="material-icons me-2 font-size-13 text-primary">check_circle</span><span><span class="fw-bold">Tweak Settings & Build Details: </span>Fine-tune everything from language and theme to payment and authentication.</span></span>
                <span class="mb-3">Ready to build your dream app? Click Generate App to get started!</span>
                <div>
                  <button class="btn w-lg  btn-primary rounded-pill" (click)="generateApp()">
                    Generate
                  </button>
                </div>
              </div> -->

            </div>
          </div>
        </div>




      </div>
      <div class="d-flex flex-column align-items-center mt-2" style="z-index: 1">

        <ng-container *ngIf="queue$ | async as queue">

          <div
            class="input-wrapper d-flex flex-column flex-grow-1 w-100 rounded-4 mx-1 mt-1"
            style="max-width: 800px"
            [class.disabled]="doneMessage || disableInput"
          >

            <!-- Uploaded image previews -->
            <div class="uploaded-images" *ngIf="queue.length > 0">
              <div class="uploaded-image-card" *ngFor="let item of queue">

                <img
                  [src]="item.thumbUrl || item.previewUrl"
                  class="uploaded-image"
                  alt="uploaded image"
                />

                <div class="upload-overlay" *ngIf="item.status === 'uploading'">
                  Uploading...
                </div>

                <div class="upload-overlay failed" *ngIf="item.status === 'failed'">
                  Failed
                </div>

                <button
                  type="button"
                  class="remove-image-btn"
                  (click)="removeUpload(item.id)"
                  [disabled]="item.status === 'uploading'"
                >
                  <span class="material-icons">close</span>
                </button>

              </div>
            </div>

            <!-- Text + buttons row -->
            <div class="composer-row d-flex align-items-center w-100">

              <button
                type="button"
                class="attach-button"
                (click)="fileInput.click()"
                [disabled]="doneMessage || disableInput"
              >
                <span class="material-icons">add</span>
              </button>

              <textarea
                id="inputArea"
                placeholder="Write your answer"
                class="rounded-pill w-100 text-wrap font-size-14 my-1"
                rows="1"
                [(ngModel)]="inputText"
                (input)="adjustHeight($event)"
                [disabled]="doneMessage || disableInput"
                (keydown.enter)="submitAnswer()"
              ></textarea>

              <button
                type="submit"
                class="send-button"
                (click)="submitAnswer()"
                [disabled]="!canSubmit(queue) || doneMessage || disableInput"
              >
                <span class="material-icons">east</span>
              </button>

            </div>

            <input
              #fileInput
              type="file"
              accept="image/*"
              multiple
              hidden
              (change)="onFileSelected($event)"
            />

          </div>

        </ng-container>

      </div>
    </div>
  </div>
</div>
